import { connect } from "react-redux";
import ClientOrders from "./ClientOrders";
import { bindActionCreators } from "redux";
import { clientOrderListing } from "services/redux/brandActivtion/baDashboard/action";

const mapStateToProps = (state) => ({
  postSalesList: state.contractListingReducer.contractpostSalesList,
  filterDropdownList: state.preSalesListReducer.filterDropdownList,
  getExternalUserData: state.createTicketReducer.getExternalUserData,
  getClientOrdersListing: state.BaDashboardReducer.getClientOrdersListing
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      clientOrderListing
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(ClientOrders);



